<template>
  <div class="side-nav-project">
    <modal
      :visible.sync="isShowAddDialog"
      title="新建项目"
      @close="handleCloseDialog"
    >
      <div class="inner-wrapper">
        <input
          type="text"
          v-model="projectName"
          class="clean-input my-input"
          placeholder="请输入项目名称"
        />
        <div class="my-btn-warpper">
          <ct-button :btnClick="handleSaveClick" type="primary">保存</ct-button>
        </div>
      </div>
    </modal>

    <modal
      title="修改项目"
      :visible.sync="visible"
      @close="handleEditDialogClose"
    >
      <div class="inner-wrapper">
        <input
          type="text"
          v-model="editProjectName"
          class="stand-input"
          placeholder="请输入风场名称"
        />
        <div class="my-btn-warpper">
          <ct-button type="primary" :btnClick="handleSaveEditClick"
            >保存</ct-button
          >
        </div>
      </div>
    </modal>

    <!-- <div class="switch" /> -->

    <div class="search-area">
      <input
        placeholder="输入搜索关键字回车"
        type="text"
        class="stand-input"
        v-model="searchkey"
        @keydown.enter="handleEnterClick"
      />
      <el-button
        class="my-btn"
        icon="el-icon-plus"
        circle
        @click="handleAddClick"
      ></el-button>
    </div>

    <div class="list-area">
      <div class="scroll">
        <div>
          <div
            v-for="(item, index) in projectList"
            :key="item.id"
            :class="[
              'list-item',
              {
                'is-active': index === activeIndex
              }
            ]"
            @click="handleItemClick(item, index)"
          >
            <i class="el-icon-bangzhu"></i>
            <div class="projectnamelength">
              {{ item.projectName }}
            </div>
            <div class="right-btn">
              <div class="edit">
                <i class="el-icon-edit" @click.stop="handleEditClick(item)"></i>
              </div>
              <div class="delete">
                <i
                  class="el-icon-delete"
                  @click.stop="handleDeleteClick(item)"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      projectName: '',
      isShowAddDialog: false,
      activeIndex: -1,
      isEdit: false,
      projectList: [],
      searchkey: '',
      editProjectName: '',
      editProjectId: ''
    };
  },
  created() {
    this.$bus.$on('updateList', this.queryProjects);
    this.queryProjects();
  },
  beforeDestroy() {
    this.$bus.$off('updateList', this.queryProjects);
  },
  mounted() {
    const container = document.querySelector('.wind-farm-main-container');
    const height = container.offsetHeight;

    const div = document.querySelector('.list-area .scroll');

    div.style.maxHeight = height - 100 + 'px';
  },
  methods: {
    queryProjects(searchKey = '') {
      this.$fetch
        .get('/windfarm/project/getProjectList', {
          showError: true,
          showLoading: true,
          params: {
            searchKey: searchKey
          }
        })
        .then(res => {
          const { data } = res;
          const { projectList = [] } = data;
          this.projectList = projectList;
        });
    },
    handleCreateProject() {
      if (!this.projectName) {
        return this.$message.warning('请输入项目名称');
      }

      if (this.projectName.length > 30) {
        return this.$message.warning('项目名不超过30个字符');
      }
      // {
      //   url: '/tzms/project/createProject',
      //   method: 'post',
      //   showSuccess: true,
      //   showError: true,
      //   data: {
      //     projectName: this.projectName
      //   }
      // }

      this.$postForm('/windfarm/project/createProject', {
        data: {
          projectName: this.projectName
        },
        showSuccess: true,
        showError: true
      }).then(() => {
        this.queryProjects();
        this.handleCloseDialog();
      });
    },
    handleItemClick(item, index) {
      this.isEdit = true;
      this.activeIndex = index;

      this.$router.push({
        name: 'project-detail',
        query: {
          projectId: item.projectId
        }
      });

      localStorage.setItem('current-project-name', item.projectName);
    },
    handleCloseDialog() {
      this.projectName = '';
      this.isShowAddDialog = false;
    },
    handleAddClick() {
      this.isShowAddDialog = true;
    },
    handleSaveClick() {
      this.handleCreateProject();
    },
    handleEnterClick() {
      this.queryProjects(this.searchkey);
    },
    handleEditDialogClose() {
      this.editProjectName = '';
      this.editProjectId = '';
      this.editItem = null;
    },
    handleEditClick(item) {
      this.visible = true;
      this.editProjectName = item.projectName;
      this.editProjectId = item.projectId;
      this.editItem = item;
    },
    handleSaveEditClick() {
      if (!this.editProjectName) {
        return this.$message.warning('请输入项目名称');
      }

      if (this.editProjectName.length > 30) {
        return this.$message.warning('项目名不超过30个字符');
      }

      this.$postForm('/windfarm/project/updateProjectName', {
        showError: true,
        showSuccess: true,
        data: {
          projectId: this.editProjectId,
          projectName: this.editProjectName
        }
      }).then(() => {
        this.editItem.projectName = this.editProjectName;
        this.visible = false;
      });
    },
    handleDeleteClick(item) {
      this.$confirm(`是否删除项目 ${item.projectName}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        this.$postForm('/windfarm/project/deleteProject', {
          showError: true,
          showSuccess: true,
          data: {
            projectId: item.projectId
          }
        }).then(() => {
          this.queryProjects();
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.inner-wrapper {
  padding: 10px 11px;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  // background-color: #c8e0f5;
}
.my-input {
  height: 40px;
  background-color: #fff;
  border-radius: 5px;
  padding: 0px 13px;
}

.my-btn-warpper {
  padding-top: 15px;
  text-align: right;
}

.list-area {
  border-radius: 0 0 10px 10px;
  flex: 1;
  .scroll {
    overflow-y: auto;
    padding-bottom: 20px;
  }
}

.side-nav-project {
  position: absolute;
  width: 217px;
  max-height: 94%;
  top: 4px;
  left: 0.3%;
  background-color: #c8e0f5;
  border-radius: 10px;
  z-index: 450;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .switch {
    position: absolute;
    right: -15px;
    top: 60px;
    width: 15px;
    height: 50px;
    background-color: #c8e0f5;
    cursor: pointer;
    z-index: 500;
  }

  .search-area {
    height: 55px;
    min-height: 55px;
    background-color: #015aad;
    display: flex;
    align-items: center;
    padding: 0 10px;
    border-radius: 10px 10px 0 0;
  }

  .my-btn {
    margin-left: 5px;
  }

  .list-item {
    height: 36px;
    display: flex;
    align-items: center;
    padding: 0px 16px;
    position: relative;
    cursor: pointer;

    &:nth-child(2n) {
      background-color: #c8e0f5;
    }

    &:nth-child(2n + 1) {
      background-color: #b4d3ee;
    }

    &.is-active {
      background-color: #5b98ce;
      color: #fff;
    }
    .right-btn {
      position: absolute;
      right: 15px;
      height: 100%;
      display: flex;
      align-items: center;
      & > div {
        height: 100%;
        width: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .el-icon-bangzhu {
      margin-right: 5px;
    }
  }
}

.projectnamelength {
  width: 130px;
  overflow: hidden; //超出的文本隐藏
  text-overflow: ellipsis; //溢出用省略号显示
  white-space: nowrap; //溢出不换行
}

.my-input {
  height: 40px;
  background-color: #fff;
  border-radius: 5px;
  padding: 0px 13px;
}
.my-btn-warpper {
  padding-top: 15px;
  text-align: right;
}
</style>
